import { FETCH_DATENSCHUTZ } from "../actions/type";

const initState = {
  empty: true
};

export default function(state = initState, action) {
  switch (action.type) {
    case FETCH_DATENSCHUTZ:
      return action.data;
    default:
      return state;
  }
}
